import { useIsShowingV4 } from 'hooks/useV4';
import { appConfig } from 'utilities/env';

/**
 * Whether the dataset comparison feature is available right now.
 *
 * Off in production (via the VITE_ENABLE_DATASET_COMPARISON env var, set per deployment) and off for
 * v4 releases, which have no comparison support yet — so it is on for 3.x on local and staging.
 *
 * Must be called from inside a versioned route, since the v4 check reads `ver` from the URL params.
 */
export const useIsDatasetComparisonEnabled = (): boolean => {
  const isShowingV4 = useIsShowingV4();
  return appConfig.isDatasetComparisonEnabled && !isShowingV4;
};
